<div class="p-grid">
    <div class="p-col-12 p-md-8 p-lg-8">
        <div class="card">
            <form (ngSubmit)="onSubmit()">
                <div *ngFor="let pergunta of perguntas" class="p-fluid p-formgrid p-grid">
                    <div *ngIf="pergunta.inativa == false" class="p-field p-col-12 p-md-12 p-lg-12">
                        <label for="Pergunta">{{pergunta.titulo}}</label>
                        <div style="width: fit-content">
                            <div *ngIf="pergunta.tipoResposta.descricao == 'SIM/NÃO'">
                                <div style="margin-bottom:5px;">
                                    <p-radioButton name="pergunta{{pergunta.id}}" value="S" [ngModel]="respostas.get(pergunta.id).valor" (ngModelChange)="setResposta(pergunta,$event)"></p-radioButton>
                                    <label for="pergunta{{pergunta.id}}_2" style="margin-bottom:0;margin-left:5px;"> {{getLabel(pergunta.id,'S')}}</label>
                                </div>
                                <div style="margin-bottom:5px;">
                                    <p-radioButton name="pergunta{{pergunta.id}}" value="N" [ngModel]="respostas.get(pergunta.id).valor" (ngModelChange)="setResposta(pergunta,$event)"></p-radioButton>
                                    <label for="pergunta{{pergunta.id}}_1" style="margin-bottom:0;margin-left:5px;"> {{getLabel(pergunta.id,'N')}}</label>
                                </div>
                            </div>
                            <div *ngIf="pergunta.tipoResposta.descricao == 'ATENDIMENTO'">
                                <div style="margin-bottom:5px;">
                                    <p-radioButton inputId="pergunta{{pergunta.id}}_3" name="pergunta{{pergunta.id}}" value="3" [ngModel]="respostas.get(pergunta.id).valor" (ngModelChange)="setResposta(pergunta,$event)"></p-radioButton>
                                    <label for="pergunta{{pergunta.id}}_3" style="margin-bottom:0;margin-left:10px;"> {{getLabel(pergunta.id,3)}}</label>
                                </div>
                                <div style="margin-bottom:5px;">
                                    <p-radioButton name="pergunta{{pergunta.id}}" value="2" [ngModel]="respostas.get(pergunta.id).valor" (ngModelChange)="setResposta(pergunta,$event)"></p-radioButton>
                                    <label for="pergunta{{pergunta.id}}_2" style="margin-bottom:0;margin-left:10px;"> {{getLabel(pergunta.id,2)}}</label>
                                </div>
                                <div style="margin-bottom:5px;">
                                    <p-radioButton name="pergunta{{pergunta.id}}" value="1" [ngModel]="respostas.get(pergunta.id).valor" (ngModelChange)="setResposta(pergunta,$event)"></p-radioButton>
                                    <label for="pergunta{{pergunta.id}}_1" style="margin-bottom:0;margin-left:10px;"> {{getLabel(pergunta.id,1)}}</label>
                                </div>
                            </div>
                            <div *ngIf="pergunta.tipoResposta.descricao == 'AVALIAÇÃO1'">
                                <p-selectButton [options]="pergunta.opcoesResposta" (onChange)="setResposta(pergunta,$event)">
                                    <ng-template let-item>
                                        <i *ngIf="item.valor == '3'" class="fa fa-circle fa-2x" aria-hidden="true"
                                            style="color:green"></i>
                                        <i *ngIf="item.valor == '2'" class="fa fa-circle fa-2x" aria-hidden="true"
                                            style="color:yellow"></i>
                                        <i *ngIf="item.valor == '1'" class="fa fa-circle fa-2x" aria-hidden="true"
                                            style="color:red"></i>
                                    </ng-template>
                                </p-selectButton>
                            </div>
                            <div *ngIf="pergunta.tipoResposta.descricao == 'AVALIAÇÃO 10'">
                                <mat-button-toggle-group name="pergunta{{pergunta.id}}" aria-label="Favorite Color" (change)="setResposta(pergunta,$event)">
                                    <mat-button-toggle value="1" ngClass="avaliacao-1">&nbsp;1</mat-button-toggle>
                                    <mat-button-toggle value="2" class="avaliacao-2">&nbsp;2</mat-button-toggle>
                                    <mat-button-toggle value="3" class="avaliacao-3">&nbsp;3</mat-button-toggle>
                                    <mat-button-toggle value="4" class="avaliacao-4">&nbsp;4</mat-button-toggle>
                                    <mat-button-toggle value="5" class="avaliacao-5">&nbsp;5</mat-button-toggle>
                                    <mat-button-toggle value="6" class="avaliacao-6">&nbsp;6</mat-button-toggle>
                                    <mat-button-toggle value="7" class="avaliacao-7">&nbsp;7</mat-button-toggle>
                                    <mat-button-toggle value="8" class="avaliacao-8">&nbsp;8</mat-button-toggle>
                                    <mat-button-toggle value="9" class="avaliacao-9">&nbsp;9</mat-button-toggle>
                                    <mat-button-toggle value="10" class="avaliacao-10">10</mat-button-toggle>
                                  </mat-button-toggle-group>
                            </div>
                            <div *ngIf="pergunta.tipoResposta.descricao == 'AVALIAÇÃO 10 - Old'">
                                <p-selectButton [options]="pergunta.opcoesResposta" (onChange)="setResposta(pergunta,$event)">
                                    <ng-template let-item>
                                        <div *ngIf="item.valor == '10'" class="circle-stack">
                                            <i class="fa fa-circle fa-2x" aria-hidden="true" style="color:#006400"></i>
                                            <span class="points-indicator">10</span>
                                        </div>
                                        <div *ngIf="item.valor == '9'" class="circle-stack">
                                            <i class="fa fa-circle fa-2x" aria-hidden="true" style="color:#32CD32"></i>
                                            <span class="points-indicator">9</span>
                                        </div>
                                        <div *ngIf="item.valor == '8'" class="circle-stack">
                                            <i class="fa fa-circle fa-2x" aria-hidden="true" style="color:#7CFC00"></i>
                                            <span class="points-indicator">8</span>
                                        </div>
                                        <div *ngIf="item.valor == '7'" class="circle-stack">
                                            <i class="fa fa-circle fa-2x" aria-hidden="true" style="color:#ADFF2F"></i>
                                            <span class="points-indicator">7</span>
                                        </div>
                                        <div *ngIf="item.valor == '6'" class="circle-stack">
                                            <i class="fa fa-circle fa-2x" aria-hidden="true" style="color:#FFFF00"></i>
                                            <span class="points-indicator">6</span>
                                        </div>
                                        <div *ngIf="item.valor == '5'" class="circle-stack">
                                            <i class="fa fa-circle fa-2x" aria-hidden="true" style="color:#FFD700"></i>
                                            <span class="points-indicator">5</span>
                                        </div>
                                        <div *ngIf="item.valor == '4'" class="circle-stack">
                                            <i class="fa fa-circle fa-2x" aria-hidden="true" style="color:#FFA500"></i>
                                            <span class="points-indicator">4</span>
                                        </div>
                                        <div *ngIf="item.valor == '3'" class="circle-stack">
                                            <i class="fa fa-circle fa-2x" aria-hidden="true" style="color:#FA8072"></i>
                                            <span class="points-indicator">3</span>
                                        </div>
                                        <div *ngIf="item.valor == '2'" class="circle-stack">
                                            <i class="fa fa-circle fa-2x" aria-hidden="true" style="color:#FF6347"></i>
                                            <span class="points-indicator">2</span>
                                        </div>
                                        <div *ngIf="item.valor == '1'" class="circle-stack">
                                            <i class="fa fa-circle fa-2x" aria-hidden="true" style="color:red"></i>
                                            <span class="points-indicator">1</span>
                                        </div>
                                        <div *ngIf="item.valor == '0'" class="circle-stack">
                                            <i class="fa fa-circle fa-2x" aria-hidden="true" style="color:rgb(150, 5, 5)"></i>
                                            <span class="points-indicator">0</span>
                                        </div>
                                    </ng-template>
                                </p-selectButton>
                            </div>
                        </div>
                        <div *ngIf="pergunta.tipoResposta.descricao == '5 ESTRELAS'">
                            <p-rating [cancel]="false" name="basic" [ngModel]="respostas.get(pergunta.id).valor" (ngModelChange)="setResposta(pergunta,$event)"></p-rating>
                        </div>
                        <div *ngIf="pergunta.tipoResposta.descricao == 'TEXTO'">
                            <textarea [ngModel]="respostas.get(pergunta.id).valor" (ngModelChange)="setResposta(pergunta,$event)" name="opcaoResposta4" type="text" pInputText></textarea>
                        </div>
                    </div>
                </div>
                <div class="p-grid">
                    <div class="p-field p-col-12"><hr width="100%"></div>
                    <div class="p-field p-col-12 p-md-6 p-lg-6">
                        <button pButton pRipple (click)="minhasSolicitacoesPendentes()" type="button"
                            label="Responder depois" class="p-button-raised p-button-secondary p-mr-2 p-mb-2 tamanho"></button>
                        <br />
                        <div style="text-align:center;" class="tamanho">
                            <a href="#" (click)="naoQueroResponder($event)" style="font-size:x-small">Não quero responder</a>
                        </div>
                    </div>
                    <div class="p-field p-col-12 p-md-6 p-lg-6">
                        <button [disabled]="!exibeBotao" pButton pRipple (click)="onSubmit()" type="button"
                            label="Salvar" class="p-button-raised p-mr-2 p-mb-2 tamanho" style="float: right;"></button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="p-col-12 p-md-4 p-lg-4">
        <div class="card">
            <h4>Informações da Solicitação</h4>
            <br />
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12">
                    <h6>TIPO DE ATENDIMENTO</h6>
                    {{ solicitacao != null ? solicitacao.tituloAtendimento : ""}}
                </div>
                <div class="p-field p-col-12">
                    <h6>NÚMERO DO ATENDIMENTO</h6>
                    {{solicitacao != null ? solicitacao.numeroAtendimento : ""}}
                </div>
                <div class="p-field p-col-12">
                    <h6>CANAL DE ENTRADA</h6>
                    {{solicitacao != null ? solicitacao.canalAtendimento : ""}}
                </div>
                <div class="p-field p-col-12">
                    <h6>QUANDO</h6>
                    {{solicitacao != null ? pipe.transform(this.solicitacao.dataAtendimento, 'dd/MM/yyyy') + " às " + pipe.transform(this.solicitacao.horaAtendimento, 'HH:mm') : ""}} 
                </div>
            </div>
            <br />
            <br />
            <h4>Dados do Aluno</h4>
            <br />
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12">
                    <h6>NOME</h6>
                    {{solicitacao != null ? solicitacao.nomeAvaliado : ""}}
                </div>
                <div *ngIf="solicitacao != null && solicitacao.matriculaAluno != null" class="p-field p-col-12">
                    <h6>MATRÍCULA</h6>
                    {{solicitacao != null ? solicitacao.matriculaAluno : ""}}
                </div>
                <div *ngIf="solicitacao != null && solicitacao.inscricaoCandidato != null && solicitacao.inscricaoCandidato != ''"
                    class="p-field p-col-12">
                    <h6>Nº DE INSCRIÇÃO</h6>
                    {{solicitacao != null ? solicitacao.inscricaoCandidato : ""}}
                </div>
                <div class="p-field p-col-12">
                    <h6>E-MAIL</h6>
                    {{solicitacao != null ? solicitacao.emailAvaliado : ""}}
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .p-lg-4{
        padding: 0.5rem !important;
    }

    .circle-stack {
        display: inline-block;
        position: relative;
    }
    .fa-circle-thin,
    .points-indicator {
        position: absolute;
        top: 0;
        left: 0;
    }

    @media screen and (max-width: 768px) {
        .tamanho{
            width: 100%;
        }
    }

    @media screen and (min-width: 769px) {
        .tamanho{
            width: 140px;
        }
    }

    @media screen and (max-width: 600px) {
        .points-indicator {
            color: #ffffff;
            text-shadow: 0.75px 1px #000000;
            font-weight: normal;
            font-size: 7px;
            line-height: 275%;
            display: inline-block;
            width: 100%;
            text-align: center;
        }
    }

    @media screen and (min-width: 601px) {
        .right{
            float:right;
        }

        .points-indicator {
            color: #ffffff;
            text-shadow: 0.75px 1px #000000;
            font-weight: bold;
            font-size: 10px;
            line-height: 275%;
            display: inline-block;
            width: 100%;
            text-align: center;
        }
    }

    ::ng-deep span.mat-button-toggle-label-content
    {
        padding: 0px 0px !important;
        min-width: 27.5px;
    }
</style>

<p-confirmDialog header="Confirmation" width="425">
</p-confirmDialog>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white;">Aguarde...</p>
</ngx-spinner>